/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {RootState} from '../../../../setup'
import {shallowEqual, useSelector} from 'react-redux'
import {AsideMenuItem} from './AsideMenuItem'
import {UserModel} from '../../../../app/modules/auth/models/UserModel'
import {UserCvModel} from '../../../../app/modules/profile/models/UserCv'

export function AsideMenuMain() {
    const intl = useIntl()
    const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
    const cv: UserCvModel = useSelector<RootState>(({auth}) => auth.cv, shallowEqual) as UserCvModel

  return (
    <>
      <AsideMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/general/gen025.svg'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      />

        {((user.role === 'manager') || (user.role === 'chercheur')) &&
            <>
                <AsideMenuItem
                    to={'/profile/edit/'+ cv.id}
                    icon='/media/icons/duotune/general/gen055.svg'
                    title={intl.formatMessage({id: 'EDHEC.LABEL.MYCV'})}
                    fontIcon='bi-layers'
                />
                <AsideMenuItem
                    to='/publications/my-publications'
                    icon='/media/icons/duotune/general/gen005.svg'
                    title={intl.formatMessage({id: 'EDHEC.LABEL.MY_PUBLICATIONS'})}
                    fontIcon='bi-layers'
                />
            </>
        }
        
        {((user.role === 'administrator') || (user.role === 'gestionnaire') || (user.role === 'assistant') || (user.role === 'consultation') ) &&
	        <>
	            <AsideMenuItem
	                to='/CV'
	                icon='/media/icons/duotune/art/art005.svg'
	                title={intl.formatMessage({id: 'EDHEC.LABEL.CV'})}
	                fontIcon='bi-layers'
	            />
           </>
        }
        
        
        {((user.role === 'administrator') || (user.role === 'gestionnaire') || (user.role === 'consultation') ) &&
	        <>
	            <AsideMenuItem
	                to='/publications/overview'
	                icon='/media/icons/duotune/general/gen004.svg'
	                title={intl.formatMessage({id: 'EDHEC.LABEL.PUBLICATIONS'})}
	                fontIcon='bi-layers'
	            />
	            <div className='menu-item'>
	                <div className='menu-content pt-8 pb-2'>
	                    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Reporting</span>
	                </div>
	            </div>
	            <AsideMenuItem
	                to='/report/custom'
	                icon='/media/icons/duotune/art/art005.svg'
	                title='Custom report'
	                fontIcon='bi-layers'
	            />
	            <AsideMenuItem
	                to='/report/overview'
	                icon='/media/icons/duotune/general/gen004.svg'
	                title='Overview report'
	                fontIcon='bi-layers'
	            />
	
	        </>
        }
        {user.role === 'manager' &&
            <>
                <div className='menu-item'>
                    <div className='menu-content pt-8 pb-2'>
                        <span className='menu-section text-muted text-uppercase fs-8 ls-1'>{intl.formatMessage({id: 'EDHEC.LABEL.MY_TEAM'})}</span>
                    </div>
                </div>
                <AsideMenuItem
                    to='/CV'
                    icon='/media/icons/duotune/art/art008.svg'
                    title={intl.formatMessage({id: 'EDHEC.LABEL.CV'})}
                    fontIcon='bi-layers'
                />
                <AsideMenuItem
                    to='/publications/overview'
                    icon='/media/icons/duotune/general/gen010.svg'
                    title={intl.formatMessage({id: 'EDHEC.LABEL.PUBLICATIONS'})}
                    fontIcon='bi-layers'
                />
            </>
        }
        
        
        {user.role === 'assistant' &&
            <>
                <AsideMenuItem
                    to='/publications/overview'
                    icon='/media/icons/duotune/general/gen010.svg'
                    title={intl.formatMessage({id: 'EDHEC.LABEL.PUBLICATIONS'})}
                    fontIcon='bi-layers'
                />
            </>
        }
    </>
  )
}
